<db-one-month-free-payment-steps [currentSubscription]="currentSubscription" [mode]="mode" [expirationDate]="expirationDate"></db-one-month-free-payment-steps>

<db-carousel [template]="reviewCarouselRef" [items]="reviewers" [height]="100"></db-carousel>

<div class="db-one-month-free-checkout-info__trust-pilot mt35">
  <div class="g2" *ngIf="!currentSubscription?.trialBoosterClient">
    <img src="assets/images/logos/services/g2_FI_2020.svg" alt="">
    <img src="assets/images/logos/services/g2_HP_2021.svg" alt="">
  </div>
  <db-trustpilot class="mr20" [class]="'db-booster-plan-checkout'"></db-trustpilot>
</div>

<ng-template #reviewCarouselRef let-item='item'>
  <div class="db-one-month-free-checkout-info__carousel">
    <div class="mb8">
      <img src="{{item.img}}" alt="">
      <i [innerHTML]="'- ' + item.title"></i>
    </div>
    <p><i [innerHTML]="item.desc"></i></p>
  </div>
</ng-template>
